const CollapseAction = {
  install(app) {
    const collapseAction = (elem, isJustShown) => {
	// console.log("start")
    	if(isJustShown) {
    		elem.removeClass("icon-down");
    		elem.addClass("icon-up")
    	} else {
    		elem.removeClass("icon-up");
    		elem.addClass("icon-down")
    	}
    };
    app.config.globalProperties.$collapseAction = collapseAction;
  },
};
export default CollapseAction;